import { DATA_REQUEST_ASYNC, SELECT_TOGGLE } from './constants'

export default function () {
  const initialState = {
    data: {
      items: [],
    },
    loader: false,
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case DATA_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: {
            ...action.payload.data,
            items: action.payload.data.items,
          },
          loader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      case DATA_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case SELECT_TOGGLE: {
        return {
          ...state,
          data: {
            ...state.data,
            items: {
              ...state.data.items,
              [action.payload.id]: {
                ...state.data.items[action.payload.id],
                selected: !state.data.items[action.payload.id].selected,
              },
            },
          },
        }
      }
      default:
        return state
    }
  }
}
